<template>
  <b-card>
    <span>本单位在岗人数{{ workStudentCount }}人，上报考核人数{{ submitStudentCount }}人；上报薪资总额：{{ submitMoney }}元</span>
    <div style="margin: 15px 0px">
      <el-row>
        <el-col :span="14">
          <el-select
            v-model="jobId"
            placeholder="请选择"
            value-key="id"
          >
            <el-option
              v-for="item in unitList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-date-picker
            v-model="timeVal"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择月"
          />
          <el-button
            type="primary"
            @click="searchTableData"
          >筛选</el-button>
        </el-col>
        <el-col
          :span="10"
          align="right"
        >
          <el-button
            v-if="checkStatus ===1"
            type="primary"
            style=""
            @click="checkFinish"
          >审核完成</el-button>
          <el-button
            v-if="checkStatus ===1"
            type="danger"
            style="margin-left: 10px"
            :disabled="tableData.length===0"
            @click="rejectDialogVisible=true"
          >全部驳回</el-button>
          <el-button
            type="primary"
            style="margin-left: 10px"
            :disabled="checkStatus !== 2"
            @click="exportExcel"
          >导出本月薪酬报表</el-button>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
        />
        <el-table-column
          prop="jobName"
          label="岗位名称"
        />
        <el-table-column
          prop="studentName"
          label="姓名"
        />
        <el-table-column
          prop="sn"
          label="学号"
        />
        <el-table-column
          prop="yearMonthStr"
          label="统计年月"
        />
        <el-table-column
          prop="timeStr"
          label="工作时间段"
        />
        <el-table-column
          prop="hourMoney"
          label="月薪"
        />
        <!-- <el-table-column prop="hours" label="当月工时">
        </el-table-column> -->
        <el-table-column
          prop="submitMoney"
          label="拟发放工资"
        >
          <template slot-scope="scope">
            {{ scope.row.submitMoney?scope.row.submitMoney:'--' }}
          </template>
        </el-table-column>
        <el-table-column label="当月实际工资">
          <template slot-scope="scope">
            <el-input
              v-if="scope.row.checkStatus === 1 || scope.row.checkStatus === 4"
              v-model="scope.row.realMoney"
              style="width: 100px"
              @blur="saveStudent(scope.row)"
            />
            <span v-else>{{ scope.row.realMoney?scope.row.realMoney:'--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totalPages"
        @current-change="handleCurrentChange"
      />
      <!-- 驳回弹窗 -->
      <el-dialog
        title="驳回"
        :visible.sync="rejectDialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <span>驳回理由：</span>
        <el-input
          v-model="rejectReason"
          maxlength="200"
          style="margin-top:15px;"
          type="textarea"
          :rows="3"
        />
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="handleClose">取 消</el-button>
          <el-button
            type="primary"
            @click="rejectAllSalary"
          >确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </b-card>
</template>

<script>
import { salaryService, jobService } from '@/api/index'
import { downLoadFile, intZ } from '@/tool/utils'

export default {
  name: 'ProvideDetail',
  data() {
    return {
      rejectDialogVisible: false,
      rejectReason: '', // 驳回理由
      jobId: null, // 岗位id
      timeVal: this.$route.query.time,
      unitList: [],
      tableData: [],
      currentPage: 1,
      totalPages: 0,
      id: this.$route.query.id, // 用工单位id
      time: null,
      submitMoney: null,
      submitStudentCount: null,
      workStudentCount: null,
      checkStatus: null,
    }
  },
  created() {
    this.id = this.$route.query.id
    this.time = this.$route.query.time
    this.initPage()
  },
  methods: {
    initPage() {
      this.getStudentList(this.id, this.time, '')
      this.getPositionList()
    },
    getStudentList(id, time, jobId) {
      let idParams = null
      if (id) {
        idParams = id
      } else {
        idParams = ''
      }
      salaryService()._studentSalaryList({
        page: this.currentPage, size: 10, unitId: idParams, time, jobId,
      }).then(res => {
        if (res.status) {
          this.tableData = res.data.list
          this.totalPages = res.data.total
          this.submitMoney = res.data.unitSalary.submitMoney
          this.submitStudentCount = res.data.unitSalary.submitStudentCount
          this.workStudentCount = res.data.unitSalary.workStudentCount
          this.checkStatus = res.data.checkStatus
        }
      })
    },
    // 筛选
    searchTableData() {
      this.getStudentList(this.id, this.timeVal, this.jobId)
    },
    // 驳回
    rejectAllSalary() {
      const params = {
        // 'checkStatus': 0,
        unitId: this.id,
        rejectReason: this.rejectReason,
        jobId: this.jobId ? this.jobId : '',
        time: this.timeVal ? this.timeVal : this.time,
      }
      salaryService()._rejectSalary(params).then(res => {
        if (res.status) {
          this.handleClose()
          this.$message.success('驳回成功！')
          this.initPage()
        }
      })
    },
    // 获取某个单位的岗位列表
    getPositionList() {
      jobService()._jobsOfUnit({ unitId: this.$route.query.id }).then(res => {
        if (res.status) {
          this.unitList = res.data
          this.unitList.unshift({ id: null, name: ' 不限岗位' })
        }
      })
    },
    checkFinish() {
      const params = {
        unitId: this.id,
        time: this.timeVal ? this.timeVal : this.time,
      }
      salaryService()._salaryFinishCheck(params).then(res => {
        if (res.status) {
          this.$message.success('操作成功')
          this.initPage()
        }
      })
    },
    saveStudent(row) {
      if (intZ(row.realMoney)) {
        const params = {
          id: row.id,
          realMoney: Number(row.realMoney),
        }
        salaryService()._saveStudentSalaryTemp(params)
      } else {
        row.realMoney = null
        this.$message.warning('请输入正整数（可含零）')
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.initPage()
    },
    // eslint-disable-next-line consistent-return
    exportExcel() {
      if (this.totalPages === 0) {
        this.$message.warning('无数据可导出')
        return false
      }
      downLoadFile('./api/salary/studentSalaryOut', { fileName: 'ddd', unitId: this.id, time: this.timeVal ? this.timeVal : this.time }, '本月薪酬报表.xls')
    },
    handleClose() {
      this.rejectDialogVisible = false
      this.rejectReason = ''
    },
  },
}
</script>

<style>

</style>
